import React, { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import Header from "../header/Header";
import Leftmenu from "../leftmenu/Leftmenu";
import "../layout/Layout.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Layout = ({ pageTitle,isDateEnabled, children }) => {
  const { theme, showMenu } = useContext(ThemeContext);

  return (
    <div className={`app ${theme} ${showMenu ? "show-menu" : "hide-menu"}`}>
      <div className="content-wrapper">
        <Leftmenu />
        <Header headerpageTitle={pageTitle} isDateEnabled ={isDateEnabled} />
        <main className="content-main-wrapper">{children}</main>
      </div>
      <ToastContainer autoClose={1500} />
    </div>
  );
};

export default Layout;
